import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

class TranslationWithComponent extends React.Component {
    render() {
        const text = this.props.intl.formatMessage({ id: this.props.id, defaultMessage: this.props.defaultMessage }, this.props.values ? this.props.values : {})
        const textParts = text.split(this.props.replaceTex)

        return (
            <span>
                {textParts.map((part, index) => (
                    <React.Fragment key={index}>
                        {part}
                        {index < (textParts.length - 1) && this.props.children}
                    </React.Fragment>
                ))}
            </span>
        )

    }
}

TranslationWithComponent.propTypes = {
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
    replaceTex: PropTypes.string.isRequired
}

export default injectIntl(TranslationWithComponent)